import { useI18n } from '@/i18n/i18n-provider';

/**
 * Shared body for tabs the reference screenshots show but TABITA has no
 * backend for yet (Notas, Formularios, Seguimientos, Mensajes de texto,
 * Correo electrónico). Rendered so the tab shell matches the reference,
 * without fabricating data or behavior — see the redesign plan's
 * "explicitly out of scope" list.
 */
export function PlaceholderTab({ label }: { readonly label: string }) {
  const { t } = useI18n();

  return (
    <div className="people-coming-soon">
      <p>{t('people.detail.comingSoon', { values: { feature: label } })}</p>
    </div>
  );
}
